import { Component, OnInit } from '@angular/core';
import {NgbAccordionConfig, NgbPanelChangeEvent} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-about.component',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };

  constructor(config: NgbAccordionConfig) { }

  ngOnInit() {
  }
  public toggleAccordian( props:NgbPanelChangeEvent ): void{
    console.log(props)
    let plusImg ='assets/images/plus.png';
    let minusImg ='assets/images/minus.png';

    //props.nextState // true === panel is toggling to an open state 
                               // false === panel is toggling to a closed state
    //props.panelId    // the ID of the panel that was clicked
    //props.preventDefault(); // don't toggle the state of the selected panel
    //(<HTMLInputElement> document.getElementById("cityToComparetxt")).value = ''; 
    //document.getElementById(props.panelId+'_span').innerText = props.nextState ? '-': '+';

    (<HTMLImageElement> document.getElementById(props.panelId+'__img')).src = props.nextState ? minusImg: plusImg;
 }
}



// WEBPACK FOOTER //
// ./src/app/component/About/about.component.ts